import { render, staticRenderFns } from "./CrmOportunidadesPage.vue?vue&type=template&id=edf1e280&scoped=true&"
import script from "./CrmOportunidadesPage.vue?vue&type=script&lang=js&"
export * from "./CrmOportunidadesPage.vue?vue&type=script&lang=js&"
import style0 from "./CrmOportunidadesPage.vue?vue&type=style&index=0&id=edf1e280&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf1e280",
  null
  
)

export default component.exports